import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';

// Components
import { BaseComponent } from './base.component';

@Component({
    selector: 'biifor-page-base',
    template: `
        NO UI TO BE FOUND HERE!
    `,
    standalone: false
})
export class PageBaseComponent extends BaseComponent {

    override ngOnInit() {
        // Call parent method
        super.ngOnInit();
        // Construction du menu de navigation
        setTimeout(() => this.buildBreadcrumbs(), 1);
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this._clearBreadcrumbs();
    }

    /**
     * Indique si des filtres sont actuellement appliqués
     */
    public get hasActiveFilters(): boolean {
        return !!(this.queryOptions.filters && this.queryOptions.filters.length > 0 || !!this.queryOptions.filtersString && this.queryOptions.filtersString.length > 0);
    }

    protected buildBreadcrumbs(): void {
        this._clearBreadcrumbs();
    }

    /**
     * Crée un MenuItem pour le breadcrumb qui navigue en arrière dans l'historique
     * Utile pour les pages de détail qui veulent revenir à la liste avec son état
     */
    protected createBackBreadcrumbItem(label: string, fallbackRoute?: string): MenuItem {
        return {
            label: label,
            command: () => {
                const backUrl = history.state?.backUrl;
                if (backUrl) {
                    this.router.navigateByUrl(backUrl);
                } else if (window.history.length > 1) {
                    this.location.back();
                } else if (fallbackRoute) {
                    this.router.navigate([fallbackRoute]);
                }
            },
            styleClass: 'cursor-pointer'
        };
    }

    protected setTitle(title: string) {
        this.titleService.setTitle(title);
    }

    private _clearBreadcrumbs(): void {
        this.appService.agentMarkerTarget = null;
        this.appService.breadcrumbItems = [];
        this.appService.historyTarget = null;
    }
}
